import { createContext, useContext } from "react";

import { SpliceTableNode } from "fond/types";

export type SelectFeatureTarget = { layerKey: string } & ({ id: string } | { fondId: string });

export type SelectFeatureOptions = {
  // Open the properties widget
  showProperties?: boolean;

  // Highlight the corresponding map feature
  highlightFeature?: boolean;

  // Zoom the map to the underlying map feature.
  zoomMap?: boolean;

  // Zoom the topological view to the node.
  zoomTopologicalView?: boolean;

  // The 'end' of the cable to select, if selecting a cable.
  end?: "upstream" | "downstream";
};

export interface TopologicalViewContextProps {
  // Whether the topological view is enabled.
  // The view may be disabled via feature flag, or by not having the expected modules.
  isEnabled: boolean;

  // Whether the topological view is available within the current context.
  isAvailable: boolean;

  data: {
    // Whether splice tables are currently being fetched.
    isFetching: boolean;

    // Whether there was an error fetching splice tables.
    isError: boolean;

    // The underlying splice nodes
    spliceNodes: SpliceTableNode[] | undefined;
  };

  // Select and interact with a feature.
  selectFeature: (target: SelectFeatureTarget, options?: SelectFeatureOptions) => void;

  // Whether a given feature is available for selection.
  hasFeature: (target: SelectFeatureTarget) => boolean;
}

export const TopologicalViewContext = createContext<TopologicalViewContextProps>(undefined!);
export const useTopologicalViewContext = (): TopologicalViewContextProps => useContext(TopologicalViewContext);
